import React, { ReactNode } from 'react';

type Props = {
  level: 'success' | 'info' | 'warning' | 'error';
  children: ReactNode;
};

export const LuiBanner = (props: Props): JSX.Element => {
  return (
    <div className="lui-msg-banner-container">
      <LuiBannerContent level={props.level}>{props.children}</LuiBannerContent>
    </div>
  );
};

export const LuiBannerContent = (props: Props): JSX.Element => {
  let materialIcon = getMaterialIconForLevel(props.level);

  return (
    <div className={`lui-msg-${props.level} lui-msg-dynamic-banner`}>
      <i className="lui-msg-status-icon material-icons-round">{materialIcon}</i>
      <div>{props.children}</div>
    </div>
  );
};

export function getMaterialIconForLevel(
  level: 'success' | 'info' | 'warning' | 'error'
) {
  switch (level) {
    case 'success':
      return 'check_circle';
    case 'info':
      return 'info';
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
  }
}
